import { Button } from '@mui/material';
import { routesPaths } from 'constants/paths';
import { useFormik } from 'formik';
import { getHeaders } from 'helper/helper';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import FormInput from '../../components/FormInput';
import { useChangePasswordMutation } from '../../redux/services/auth';
import './ChangePassword.scss';

const ChangePasswordSchema = Yup.object().shape({
  newPassword: Yup.string()
    .min(8, 'Minimum 8 characters are required')
    .required('New Password is required'),
  confirmPassword: Yup.string()
    .min(8, 'Minimum 8 characters are required')
    .oneOf([Yup.ref('newPassword'), null], "Passwords don't match!")
    .required('Password confirmation is required'),
});
export const ChangePassword = () => {
  const [changePassword] = useChangePasswordMutation();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      newPassword: '',
      confirmPassword: '',
    },
    validationSchema: ChangePasswordSchema,
    onSubmit: async (values) => {
      const headers = await getHeaders();
      const res: any = await changePassword({
        headers,
        body: values,
      });
      if (res.data) {
        toast.success(t('success_password_changed'));
        formik.resetForm();
      } else {
        toast.error(res.error.data.message);
      }
    },
  });

  const handleBack = () => navigate(routesPaths.help);

  const { errors, touched } = formik;
  return (
    <div className="change-password d-flex justify-content-center align-items-center flex-column w-100 h-100">
      <div className="change-password-form-content d-flex flex-column mb-2">
        <h2 className="title text-center mb-3">{t('title_change_password')}</h2>
        <h5 className="subtitle page-title text-center mb-5">
          {t('change_password_form_title')}
        </h5>

        <form
          onSubmit={formik.handleSubmit}
          noValidate
          className="d-flex flex-column flex-grow-1"
        >
          <FormInput
            label={t('label_new_password')}
            type="password"
            name="newPassword"
            value={formik.values.newPassword}
            onChange={formik.handleChange}
            touched={touched.newPassword}
            error={errors.newPassword}
          />
          <FormInput
            label={t('label_confirm_password')}
            type="password"
            name="confirmPassword"
            value={formik.values.confirmPassword}
            onChange={formik.handleChange}
            touched={touched.confirmPassword}
            error={errors.confirmPassword}
          />

          <footer className="w-100 d-flex p-0 justify-content-between flex-row flex-grow-1 align-items-end">
            <Button color="primary" variant="outlined" onClick={handleBack}>
              {t('back')}
            </Button>
            <Button color="primary" variant="contained" type="submit">
              {t('submit')}
            </Button>
          </footer>
        </form>
      </div>
    </div>
  );
};
